import React, { useEffect, useState } from 'react';
import ShowUserRank from './ShowUserRank';
import './userRank.scss';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useOutletContext } from 'react-router';
import { setLogout } from '../../../reducer/authentication';

function UserRank(props) {
    const { userRank, privilege } = useSelector((state) => state.session);
    const dispatch = useDispatch();
    const onLogout = () => dispatch(setLogout());
    const [ranksArr, setRanksArr] = useState([]);
    async function getUserRanks() {
        const response = await axios.get(`${API_URL}/monitoring-manage/getRanks`);
        setRanksArr([...response.data]);
    }
    useEffect(() => {
        if (!privilege?.userRank.read) onLogout();
    }, [privilege]);
    useEffect(() => {
        getUserRanks();
    }, [])
    return (
        <React.Fragment>
            <ShowUserRank ranksArr={ranksArr} />
        </React.Fragment>
    );
}

export default UserRank;